module.exports = __webpack_public_path__ + "img/me.3acde40d.jpg";